import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../config/api";
import "./AdminDashboard.css";

function AdminDashboard() {
  const navigate = useNavigate();

  const [totalProducts, setTotalProducts] = useState(0);

  const adminData = JSON.parse(
    localStorage.getItem("adminData") || "{}"
  );

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/products`
        );

        const data = await response.json();

        if (data.success && Array.isArray(data.products)) {
          setTotalProducts(data.products.length);
        } else {
          setTotalProducts(0);
        }
      } catch (error) {
        console.error("Failed to fetch products:", error);
        setTotalProducts(0);
      }
    };

    fetchProducts();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminData");

    navigate("/admin/login");
  };

  return (
    <main className="tv-admin-dashboard">
      <aside className="tv-admin-sidebar">
        <div className="tv-admin-sidebar-brand">
          <img
            src="/images/logo.png"
            alt="Time Valley"
          />

          <span>ADMINISTRATION</span>
        </div>

        <nav className="tv-admin-sidebar-nav">
          <button className="tv-admin-nav-active">
            Dashboard
          </button>

          <button
            onClick={() => navigate("/admin/products")}
          >
            <span>01</span>
            Add New Watch
            <em>+</em>
          </button>

          <button
            onClick={() => navigate("/admin/products")}
          >
            <span>02</span>
            Products
          </button>

          <button
            onClick={() => navigate("/admin/collections")}
          >
            <span>03</span>
            Collections
          </button>

          <button>
            <span>04</span>
            Orders
          </button>

          <button>
            <span>05</span>
            Customers
          </button>
        </nav>

        <div className="tv-admin-sidebar-bottom">
          <button
            onClick={handleLogout}
            className="tv-admin-logout"
          >
            <span>↗</span>
            Sign Out
          </button>
        </div>
      </aside>

      <section className="tv-admin-main">
        <header className="tv-admin-header">
          <div>
            <span className="tv-admin-header-eyebrow">
              TIME VALLEY WATCHES
            </span>

            <h1>
              Good Evening{" "}
              <span>
                {adminData.name || "Admin"}
              </span>
            </h1>
          </div>

          <div className="tv-admin-header-profile">
            <div className="tv-admin-profile-avatar">
              {adminData.name
                ? adminData.name.charAt(0).toUpperCase()
                : "A"}
            </div>

            <div>
              <strong>
                {adminData.name || "Administrator"}
              </strong>

              <small>Administrator</small>
            </div>
          </div>
        </header>

        <div className="tv-admin-stats">
          <div className="tv-admin-stat-card">
            <span>01</span>
            <small>Total Products</small>

            <strong>{totalProducts}</strong>

            <em
              onClick={() => navigate("/admin/collections")}
              style={{ cursor: "pointer" }}
            >
              View collection →
            </em>
          </div>

          <div className="tv-admin-stat-card">
            <span>02</span>
            <small>Total Orders</small>

            <strong>0</strong>

            <em>View orders →</em>
          </div>

          <div className="tv-admin-stat-card">
            <span>03</span>
            <small>Customers</small>

            <strong>0</strong>

            <em>View customers →</em>
          </div>

          <div className="tv-admin-stat-card">
            <span>04</span>
            <small>Revenue</small>

            <strong>Rs 0</strong>

            <em>View analytics →</em>
          </div>
        </div>

        <div className="tv-admin-welcome">
          <div>
            <span>TIME VALLEY ADMINISTRATION</span>

            <h2>
              Your Store.
              <br />
              <em>Your Control.</em>
            </h2>

            <p>
              Manage your watches, collections, orders and
              customers from one refined administration space.
            </p>
          </div>

          <div className="tv-admin-welcome-mark">
            TIME
            <br />
            VALLEY
          </div>
        </div>

        <div className="tv-admin-section-heading">
          <div>
            <span>MANAGEMENT</span>

            <h2>Quick Actions</h2>
          </div>
        </div>

        <div className="tv-admin-actions">
          <button
            onClick={() => navigate("/admin/products")}
          >
            <span>01</span>
            <strong>Add New Watch</strong>
            <em>+</em>
          </button>

          <button
            onClick={() => navigate("/admin/collections")}
          >
            <span>02</span>
            <strong>Manage Collections</strong>
            <em>→</em>
          </button>

          <button>
            <span>03</span>
            <strong>View Orders</strong>
            <em>→</em>
          </button>
        </div>
      </section>
    </main>
  );
}

export default AdminDashboard;
